import angular from 'angular';

import ComponentModule from './component';
import CalendarHeaderComponent from './calendar-header.cmpt';

export default angular
    .module('application.scene.authorized.scene.calendar.component.calendar-header', [
        ComponentModule.name
    ])
    .component(CalendarHeaderComponent.selector, CalendarHeaderComponent);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-header/index.js